import { $ } from '@/libs/jquery/index'
import { routes } from '@/libs/routes/index'
import { IBpopupDisplayOptions, PopUps } from '@/utilities/popups'

interface IOptionsData {
  popupModalcolor?: string
  popupOpacity?: string
  verticalScroll?: string
}

export class ModalsFooters {
  private selectors: ISelectors = {
    popup: '[data-module-popup]',
  }

  public constructor() {
    this.init()
  }

  private init(): void {
    this.initListeners()
  }

  private initListeners(): void {
    $('body').on('click', this.selectors.popup, (e) => {
      e.preventDefault()
      const slug = e.currentTarget.dataset.slug

      const options = this.generatePopupOptionsFromHTML(e.currentTarget.dataset)
      PopUps.showPopupByUrl(routes.info_item_path({slug}), options, true)
    })
  }

  private generatePopupOptionsFromHTML(dataset: IOptionsData): IBpopupDisplayOptions {
    const options = {
      modalColor: dataset.popupModalcolor,
      opacity: parseInt(dataset.popupOpacity, 10),
      verticalScroll: dataset.verticalScroll,
    }

    return options
  }
}
